import Root from "./Accordion.svelte";
import AccordionItem from "./AccordionItem.svelte";
export const Accordion = Object.assign(Root, {
    Item: AccordionItem,
});
